import EventBase from './EventBase'
import EventID from './EventID'

/**
 * 603 - 视频节点事件
 */

export default class EventMediaPlayNode extends EventBase {
  /**
   * 事件ID
   */
  Code = EventID.MediaPlayNode

  constructor() {
    super()
    this.Parameter = ['0', '0', '0', '0', '0']
  }

  /**
   * 视频ID
   */
  get VideoId() {
    return parseInt(this.Parameter?.[0] ?? '')
  }
  set VideoId(value) {
    this.Parameter && (this.Parameter[0] = value.toString())
  }

  /**
   * 时间点（秒）
   */
  get TimePoint() {
    return parseInt(this.Parameter?.[1] ?? '')
  }
  set TimePoint(value) {
    this.Parameter && (this.Parameter[1] = value.toString())
  }

  /**
   * 视频如何【1表示同时执行，2表示暂停直到事件执行完，3表示停止播放】
   */
  get VideoPlayType() {
    return parseInt(this.Parameter?.[2] ?? '')
  }
  set VideoPlayType(value) {
    this.Parameter && (this.Parameter[2] = value.toString())
  }

  /**
   * 描述信息
   */
  get Description() {
    return this.Parameter?.[3] || ''
  }
  set Description(value) {
    this.Parameter && (this.Parameter[3] = value.toString())
  }

  /**
   * 是否选项
   */
  get IsSelects() {
    return parseInt(this.Parameter?.[4] ?? '')
  }
  set IsSelects(value) {
    this.Parameter && (this.Parameter[4] = value.toString())
  }
  /**
   * 分支选项位置
   */
  public ChoicePos!: number
  /**
   * 描述信息
   */
}
